<template>
  <div>
    <section>
      <b-col class="d-flex justify-content-between px-0 pt-25">
        <b-button
          v-b-modal.modal-create-edit-language
          variant="primary"
          :disabled="isLoading"
          size="sm"
        >
          <GjIcon
            class="mr-50"
            name="Plus"
          />
          {{ $tk('ClientPortal.Admin.CreateLanguage') }}
        </b-button>
        <SearchInputField
          :disabled="isLoading"
          :placeholder="$tk('Admin.Accounts.SearchByName')"
          @onInputSearch="onSearchChange"
        />
      </b-col>
      <b-card
        class="my-50 admin-table--no-pagination-smaller"
        no-body
      >
        <Table
          :data="languages"
          :columns="languagesColumns"
          :is-loading="isLoading"
          class="admin-table__data"
          type-of-table="languages"
          :enable-pagination="false"
          :enable-sort="false"
        />

        <b-modal
          id="modal-create-edit-language"
          :ok-title="$tk('ClientPortal.Form.Actions.Save')"
          :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
          centered
          cancel-variant="outline-secondary"
          size="md"
          :title="$tk('ClientPortal.Admin.CreateLanguage')"
          no-enforce-focus
          :ok-disabled="saving || isFormComplete()"
          @show="getLanguageModel"
          @change="getLanguages"
          @ok="save"
        >
          <b-form-group
            :label="$tk('ClientPortal.Form.Name')"
            label-size="xs"
            :invalid-feedback="errors['Name']"
          >
            <b-form-input
              v-model="languageModel.name"
              size="sm"
              type="text"
              :placeholder="$tk('ClientPortal.Form.NamePlaceholder')"
              :state="errors['Name'] == null ? null : false"
            />
          </b-form-group>
          <b-form-group
            :label="$tk('ClientPortal.Admin.LanguageCode')"
            label-size="xs"
            :invalid-feedback="errors['Code']"
          >
            <b-form-input
              v-model="languageModel.code"
              size="sm"
              type="text"
              :placeholder="$tk('ClientPortal.Admin.LanguageCodePlaceholder')"
              :state="errors['Code'] == null ? null : false"
            />
          </b-form-group>

          <b-form-group
            :label="$tk('ClientPortal.Admin.DisplayOrder')"
            label-size="xs"
            :invalid-feedback="errors['Order']"
          >
            <b-form-input
              v-model="languageModel.order"
              size="sm"
              type="number"
              :placeholder="$tk('ClientPortal.Admin.DisplayOrderPlaceholder')"
              :state="errors['Order'] == null ? null : false"
            />
          </b-form-group>
          <b-form-group
            :label="$tk('ClientPortal.Admin.Published')"
            label-size="xs"
            class="mb-0"
          >
            <b-form-checkbox
              v-model="languageModel.published"
            />
          </b-form-group>
        </b-modal>
      </b-card>
    </section>
  </div>
</template>

<script>
import { VBModal } from 'bootstrap-vue'
import {
  onMounted,
  ref,
  computed,
} from '@vue/composition-api'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import Table from '@/components/Table.vue'
import SearchInputField from '@/components/SearchInputField.vue'
import notification from '@/mixins/toastification'
import LanguagesService from '@/api/admin/languages.service'
import translation from '@/mixins/translate'
import store from '@/store'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    // Bootstrap Components
    SearchInputField,
    GjIcon,
    Table,
  },
  mixins: [notification],
  setup() {
    const languagesColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.Languages.Id'),
        field: 'id',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Languages.Name'),
        field: 'name',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Languages.Order'),
        field: 'order',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Languages.Published'),
        field: 'published',
        sortable: false,
      },
    ]
    const isLoading = ref(false)
    const languages = computed(() => store.getters.getLanguages)
    const errors = ref({})
    const languageModel = ref({})
    const saving = ref(false)

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getLanguages')
      languages.value.searchTerm = ''
      isLoading.value = false
    })

    const getLanguages = async () => {
      await store.dispatch('getLanguages')
    }

    const getLanguageModel = () => {
      languageModel.value = store.getters.getLanguageModel
      errors.value = {}
      store.commit('SET_LANGUAGE_MODEL', {})
    }

    const isFormComplete = () => {
      const { name, code, order } = languageModel.value
      return !(name && code && order)
    }

    const save = async bvModalEvt => {
      bvModalEvt.preventDefault()
      saving.value = true
      let response = {}
      try {
        if (!languageModel.value.id) {
          response = await LanguagesService.createLanguage(languageModel.value)
        } else {
          response = await LanguagesService.updateLanguage(languageModel.value)
        }
        if (response.saved) {
          bvModalEvt.vueTarget.hide('modal-create-edit-language')
          response.message
            ? notification.methods.success(response.message)
            : notification.methods.success(translation.methods.$tk('ClientPortal.Admin.ChangesHaveBeenSavedSuccesfully'))
        } else {
          notification.methods.error(response.message)
          errors.value = response.errors
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        saving.value = false
        await store.dispatch('getLanguages')
      }
    }

    const onSearchChange = async value => {
      languages.value.searchTerm = value
    }

    return {
      isLoading,
      languages,
      errors,
      languageModel,
      saving,
      getLanguageModel,
      getLanguages,
      save,
      isFormComplete,
      onSearchChange,
      languagesColumns,
    }
  },
}
</script>
